// extracted by mini-css-extract-plugin
export var deliveryRow = "_l3-a";
export var fixedHeight = "_l3-4";
export var freightLogo = "_l3-9";
export var fullWidth = "_l3-3";
export var priceColumn = "_l3-5";
export var radioSelected = "_l3-7";
export var radioUnselected = "_l3-6";
export var selectedOption = "_l3-2";
export var selectedOptionContainer = "_l3-1";
export var selection = "_l3-0";
export var tallSkeletonText = "_l3-8";